import { createAction } from 'redux-act';

import config from 'config';

import { isNotEmpty } from '@utils/helpers';
import { parseQuery } from '@utils/index';

export const moduleName = 'settings';

export const isDevelopment = config.get('client.env') === 'development';

export const saveConfiguration = createAction<any>(`${moduleName}/SAVE_CONFIGURATION`);
export const saveQuery = createAction<any>(`${moduleName}/SAVE_QUERY`);

export const parseAndSaveQuery = (query) => (dispatch) => {
    if (isNotEmpty(query)) {
        const parsedQuery: any = parseQuery(query);

        dispatch(saveQuery(parsedQuery));
    }
};
